import { render, staticRenderFns } from "./fair-view.vue?vue&type=template&id=abb65c06&scoped=true"
import script from "./fair-view.vue?vue&type=script&lang=js"
export * from "./fair-view.vue?vue&type=script&lang=js"
import style0 from "./fair-view.vue?vue&type=style&index=0&id=abb65c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb65c06",
  null
  
)

export default component.exports